import React from 'react';
import { StubLabel } from 'Components/Texts';
import BillingHistoryItem from './BillingHistoryItem';
import './BillingHistoryList.css';

const BillingHistoryList = ({ orders = [] }) => (
  <section className="billingListSection">
    <ul className="billingListContainer">
      <li className="billingListItem billingListHeader">
        <div className="sectionFlex">
          <span className="firstCol">
            <StubLabel text="Date" />
          </span>
          <span className="secondCol">
            <StubLabel text="Description" />
          </span>
          <span className="thirdCol">
            <StubLabel text="Service period" />
          </span>
          <span className="fourCol">
            <StubLabel text="Amount" />
          </span>
        </div>
      </li>

      {orders.map((order, index) => (
        <BillingHistoryItem key={`${order.orderID}-${index}`} payment={order} />
      ))}
    </ul>
  </section>
);

export default BillingHistoryList;
